import styled from 'styled-components'

export const OutageItemWrapper = styled.div`
  margin-bottom: 14px;

  &:not(:last-child) {
    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.border.color};
  }

  h6 {
    margin-bottom: 4px;
  }

  p {
    margin-bottom: 0;
  }

  svg {
    opacity: 0.3;
  }
  .text-muted {
    opacity: 0.6;
  }

  svg {
    vertical-align: middle;
  }
`
